module.exports = __webpack_public_path__ + "img/default-avatarurl.769c69d6.png";